import { getAssetTypeIcon, useOpenAsset } from '../../../data/assets/helpers';
import { TpAssetInfo } from '../../../data/assets/interfaces';
import styles from '../StartPage.module.scss';
import { FancyButton } from '../../../components/primitives/FancyButton';
import { useEffect, useState } from 'react';

interface TpQuickAccessProps {
  ontology: any;
  assets: TpAssetInfo[];
  dashboardtemplate: any;
}

enum AccessType {
  assetLink = 'assetLink',
  externalLink = 'externalLink',
}

type TpQuickAccessElement = {
  id: string;
  title: string;
  description: string;
  accessType: AccessType;
  assetType?: string;
  asset?: string;
  url?: string;
};

const QuickAccess = (props: TpQuickAccessProps) => {
  const { ontology, assets, dashboardtemplate } = props;

  const quickAccessElements: TpQuickAccessElement[] = dashboardtemplate.elements;
  const [validLinks, setValidLinks] = useState<TpQuickAccessElement[]>([]);
  const openAsset = useOpenAsset();

  const findAssetByName = (assetName: string): any => {
    return assets.find((asset: TpAssetInfo) => asset.name === assetName);
  };

  useEffect(() => {
    const validLinks = quickAccessElements.filter((element: any) => {
      if (element.accessType === AccessType.assetLink) {
        return assets.find((asset: TpAssetInfo) => asset.name === element.asset);
      } else if (element.accessType === AccessType.externalLink) {
        return element.url;
      }
    });
    setValidLinks(validLinks);
  }, [assets, dashboardtemplate]);

  const getQuickAccessByType = (element: any): any => {
    const accessType = element.accessType;
    if (accessType === AccessType.assetLink) {
      const assetOntology = ontology.assetTypes[element.assetType];
      return (
        <FancyButton
          iconName={getAssetTypeIcon(assetOntology)}
          large={true}
          onClick={() => {
            openAsset(findAssetByName(element.asset).id);
          }}
        >
          {element.description}
        </FancyButton>
      );
    } else if (accessType === AccessType.externalLink) {
      return (
        <FancyButton
          iconName="fad:globe-pointer"
          large={true}
          onClick={() => {
            window.open(element.url, '_blank');
          }}
        >
          {element.description}
        </FancyButton>
      );
    }
  };

  if (Object.values(ontology.assetTypes).length == 0 || !assets || validLinks.length == 0) return <></>;
  return (
    <>
      <div className={styles.quickAccessWrapper}>
        {validLinks.map((element: TpQuickAccessElement, index: string) => {
          return (
            <div key={`${element.id}-${index}`} style={{ display: 'inline-block', margin: '0 20px 0 0' }}>
              {getQuickAccessByType(element)}
            </div>
          );
        })}
      </div>
      <div key="quick-access-separator" className={styles.separator} />
    </>
  );
};

export default QuickAccess;
